import { TokenResponse } from '@ca/common/types'
import * as Sentry from '@sentry/react-native'
const WARN_DIFF_THRESHOLD_MS = 10 * 60 * 1000

const warnDiff = (timeMs?: number, location?: string) => {
  if (!timeMs) {
    return
  }
  const now = Date.now()
  const diff = timeMs - now
  if (Math.abs(diff) > WARN_DIFF_THRESHOLD_MS) {
    const extra = {
      diff,
      now,
      timeMs,
    }
    const error = new Error('High time diff')
    console.warn(error.message, extra)
    Sentry.captureException(error.message, {
      level: 'warning',
      tags: {
        location,
      },
      extra,
    })
  }
}

const isTokenValid = (exp?: number, timeMs?: number) => {
  if (exp == null) {
    return false
  }

  warnDiff(timeMs, 'isTokenValid')

  const nowSeconds = Math.floor((timeMs ?? Date.now()) / 1000)

  return exp > nowSeconds
}

const isEntityValid = (item?: TokenResponse | null, timeMs?: number) => {
  return (
    isTokenValid(item?.exp, timeMs) || isTokenValid(item?.refresh_exp, timeMs)
  )
}

const shouldRefresh = (item?: TokenResponse | null, time?: number) => {
  if (!item) {
    return false
  }
  const { refresh_token, token, exp, refresh_exp } = item
  if (!refresh_token || !token || isTokenValid(exp, time)) {
    return false
  }
  if (isTokenValid(refresh_exp, time)) {
    return true
  }
  return false
}

const SessionUtils = {
  isTokenValid,
  isEntityValid,
  shouldRefresh,
}

export default SessionUtils
